import { useState, useEffect } from 'react';
import { catchError, tap } from "rxjs/operators";
import { forkJoin } from "rxjs";
import { Categories } from 'Models';
import { CategoriesService } from 'Services';
import { useSnackbar } from "notistack";

export function useAllCategories() {
    const [categories, setCategories] = useState<Categories[]>([]);
    const {enqueueSnackbar} = useSnackbar();

    useEffect(() => {
        const observable = forkJoin({
            categories: CategoriesService.GetAll()
        });
        observable.pipe(
            tap(response => {
                setCategories(response.categories);
            }),
            catchError(error => {
                setCategories([]);
                enqueueSnackbar(error.toString(), {variant: 'error'});
                return Promise.reject(error);
            })
        ).subscribe();
    }, [enqueueSnackbar]);
    return { categories, setCategories };
}